"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HeaderCharmType;
(function (HeaderCharmType) {
    HeaderCharmType[HeaderCharmType["FeedbackCharm"] = 0] = "FeedbackCharm";
    HeaderCharmType[HeaderCharmType["FeatureFlagsCharm"] = 1] = "FeatureFlagsCharm";
    HeaderCharmType[HeaderCharmType["HelpCharm"] = 2] = "HelpCharm";
    HeaderCharmType[HeaderCharmType["PersonaCharm"] = 3] = "PersonaCharm";
    HeaderCharmType[HeaderCharmType["SettingsCharm"] = 4] = "SettingsCharm";
    HeaderCharmType[HeaderCharmType["WaffleCharm"] = 5] = "WaffleCharm";
    HeaderCharmType[HeaderCharmType["DiagnosticsCharm"] = 6] = "DiagnosticsCharm";
    HeaderCharmType[HeaderCharmType["GetStartedCharm"] = 7] = "GetStartedCharm";
})(HeaderCharmType || (HeaderCharmType = {}));
exports.default = HeaderCharmType;
//# sourceMappingURL=HeaderCharmType.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-store/lib/store/schema/HeaderCharmType.js
// module id = 1624
// module chunks = 2 87 105 106 107